import translations from '../../../../translations';
import type { column } from '../../../../types/page';
import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';

const NUMBER_OF_ROWS = 5;

const Table = ({
    label,
    columns,
    isSearchable,
    attributes,
}: {
    label: string | null;
    columns: column[] | null;
    isSearchable?: boolean;
    attributes: { [key: string]: string } | null;
}) => {
    if (!columns) {
        return <p>{translations.PAGE_BUILDER_no_columns}</p>;
    }

    const hasPaginationButtons =
        typeof attributes?.['$paginationButtons'] === 'string' &&
        attributes?.['$paginationButtons'].toLowerCase() === 'true';

    const columnsToDisplay = columns
        .filter((column) => column.isDisplayValue)
        .sort((a, b) => a.order - b.order)
        .map((column) => (
            <th key={column.typeElementPropertyId} title={column.label ?? ''}>
                {column.label}
            </th>
        ));

    const cellsToDisplay = columns.map((column) => (
        <td key={`cell-${column.typeElementPropertyId}`}>-</td>
    ));

    const rowsToDisplay = [...new Array(NUMBER_OF_ROWS)].map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: No alternative to index
        <tr key={i}>{cellsToDisplay}</tr>
    ));

    return (
        <div data-testid="component-preview-table" className="component-preview-table">
            <PreviewComponentLabel labelText={label || ''} />
            {isSearchable ? (
                <div className="component-preview-input margin-bottom form-control-width">
                    <input placeholder="Search" type="text" />
                </div>
            ) : null}
            <table id="preview-table">
                <thead>
                    <tr>{columnsToDisplay}</tr>
                </thead>
                <tbody>{rowsToDisplay}</tbody>
            </table>
            {hasPaginationButtons && (
                <div className="component-preview-pagination">
                    <button
                        onClick={() => {}}
                        type="button"
                        className="component-preview-pagination-button"
                    >
                        <CaretLeft />
                    </button>
                    <span className="component-preview-pagination-label">Page 1</span>
                    <button
                        onClick={() => {}}
                        type="button"
                        className="component-preview-pagination-button"
                    >
                        <CaretRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default Table;
